import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LangProvider } from './i18n';
import { GeoProvider } from './geo';
import ScrollToTop from './components/ScrollToTop';
import RouteSeo from './components/RouteSeo';
import { GuestRoute, ProtectedRoute } from './routes';
import Home from './pages/Home';
import Football from './pages/Football';
import Basketball from './pages/Basketball';
import Tennis from './pages/Tennis';
import IceHockey from './pages/IceHockey';
import TableTennis from './pages/TableTennis';
import Volleyball from './pages/Volleyball';
import Rugby from './pages/Rugby';
import AmericanFootball from './pages/AmericanFootball';
import Handball from './pages/Handball';
import MMA from './pages/MMA';
import MatchDetail from './pages/MatchDetail';
import Auth from './pages/Auth';
import MyBets from './pages/MyBets';
import Deposit from './pages/Deposit';
import Withdrawal from './pages/Withdrawal';
import ProfileEdit from './pages/ProfileEdit';
import Transactions from './pages/Transactions';
import Results from './pages/Results';
import LiveCalendar from './pages/LiveCalendar';
import LivePage from './pages/LivePage';
import LiveMatch from './pages/LiveMatch';
import MatchResult from './pages/MatchResult';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import License from './pages/License';
import About from './pages/About';
import KycPolicy from './pages/KycPolicy';
import HelpCenter from './pages/HelpCenter';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailed from './pages/PaymentFailed';
import Favoris from './pages/Favoris';
import './css/index.css';

const API = process.env.REACT_APP_API_BASE_URL;

function App() {
  useEffect(() => {
    const stored = localStorage.getItem('user');
    // On n'appelle les endpoints protégés que si un token est présent, sinon
    // un 401 déclencherait une redirection vers /auth depuis la page publique.
    if (!stored || !localStorage.getItem('token')) return;
    const user = JSON.parse(stored);
    if (!user?.id) return;

    fetch(`${API}/api/user/infos.php?id=${user.id}`)
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          localStorage.setItem('user', JSON.stringify({ ...user, ...data.data }));
          window.dispatchEvent(new Event('userUpdated'));
        }
      })
      .catch(() => {});

    fetch(`${API}/api-bet/bets/check-results-test.php?user_id=${user.id}`)
      .then((r) => r.json())
      .then((data) => {
        if (data.success && data.results?.won > 0) {
          return fetch(`${API}/api/user/infos.php?id=${user.id}`)
            .then((r) => r.json())
            .then((ud) => {
              if (ud.success) {
                const cur = JSON.parse(localStorage.getItem('user') || '{}');
                localStorage.setItem('user', JSON.stringify({ ...cur, ...ud.data }));
                window.dispatchEvent(new Event('userUpdated'));
              }
            });
        }
      })
      .catch(() => {});
  }, []);

  return (
    <GeoProvider>
    <LangProvider>
    <Router>
      <ScrollToTop />
      <RouteSeo />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sports" element={<Navigate to="/football" replace />} />
        <Route path="/football" element={<Football />} />
        <Route path="/basketball" element={<Basketball />} />
        <Route path="/tennis" element={<Tennis />} />
        <Route path="/ice-hockey" element={<IceHockey />} />
        <Route path="/table-tennis" element={<TableTennis />} />
        <Route path="/volleyball" element={<Volleyball />} />
        <Route path="/rugby" element={<Rugby />} />
        <Route path="/american-football" element={<AmericanFootball />} />
        <Route path="/handball" element={<Handball />} />
        <Route path="/mma" element={<MMA />} />
        <Route path="/match/:sport/:id" element={<MatchDetail />} />
        <Route path="/mybets" element={<ProtectedRoute><MyBets /></ProtectedRoute>} />
        <Route path="/deposit" element={<ProtectedRoute><Deposit /></ProtectedRoute>} />
        <Route path="/withdrawal" element={<ProtectedRoute><Withdrawal /></ProtectedRoute>} />
        <Route path="/profile/edit" element={<ProtectedRoute><ProfileEdit /></ProtectedRoute>} />
        <Route path="/transactions" element={<ProtectedRoute><Transactions /></ProtectedRoute>} />
        <Route path="/results" element={<Results />} />
        <Route path="/live-betting" element={<LivePage />} />
        <Route path="/live-calendar" element={<LiveCalendar />} />
        <Route path="/live/:matchId" element={<LiveMatch />} />
        <Route path="/match-result" element={<MatchResult />} />
        <Route path="/terms"    element={<Terms />} />
        <Route path="/privacy"  element={<Privacy />} />
        <Route path="/license"  element={<License />} />
        <Route path="/about"    element={<About />} />
        <Route path="/kyc"      element={<KycPolicy />} />
        <Route path="/help"     element={<HelpCenter />} />
        <Route path="/favoris"  element={<ProtectedRoute><Favoris /></ProtectedRoute>} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/failed"  element={<PaymentFailed />} />
        <Route path="/auth" element={
          <GuestRoute>
            <Auth />
          </GuestRoute>
        } />
      </Routes>
    </Router>
    </LangProvider>
    </GeoProvider>
  );
}

export default App;
